<template>
    <div class="shortcut-menu" ref="root">

        <div class="shortcut-menu-content" v-popover:popover>
            <i class="iconfont icon-kuaijiecaidan-fill"></i>
            <span>{{ $t('shortCutMenu.shortcutEntry') }}</span>
        </div>

        <el-popover ref="popover" placement="bottom-start" width="324" trigger="hover" @show="showPopoverEvents"
            popper-class="shortcut-menu-prpover">
            <div class="header">
                <div class="title">{{ $t('shortCutMenu.shortcutEntry') }}</div>
                <div class="config" @click="showConfigEvents">
                    <i class="iconfont icon-shezhi-line"></i>
                    <span>{{ $t('shortCutMenu.customize') }}</span>
                </div>
            </div>
            <div class="empty" v-if="selectMenuList.length == 0">
                <img :src="EmptyUrl" class="empty-img" />
                <div class="tips">{{ $t('shortCutMenu.noShortcutMenu') }}<br />{{ $t('shortCutMenu.noShortcutMenuTip') }}
                </div>
            </div>
            <div v-else class="content">
                <div class="warpper">
                    <div class="menu-item" v-for="item in selectMenuList" :key="item.key" @click="jumpUrl(item)"
                        :title="item.name">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </el-popover>
        <el-dialog :visible.sync="showConfig" append-to-body class="shortcut-menu-dialog" width="640px">
            <div slot="title" class="title">{{ $t('shortCutMenu.customShortcutEntry') }}</div>
            <div slot="footer" class="footer">
                <el-button size="mini" @click="showConfig = false">{{ $t('common.cancel') }}</el-button>
                <el-button size="mini" type="primary" @click="submit" :loading="loading">{{ $t('common.confirm') }}</el-button>
            </div>
            <div class="left">
                <div class="title">{{ $t('shortCutMenu.availableFunctions') }}
                    <span class="tips">{{ $t('shortCutMenu.totalCount', { count: allMenu.length }) }}</span>
                </div>
                <div class="content">
                    <el-input :placeholder="$t('shortCutMenu.menuSearch')" size="mini" v-model="leftSearchValue"
                        @keyup.enter.native="leftSearchEvents">
                        <el-button slot="append" @click="leftSearchEvents" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-tree ref="tree" :data="menuList" show-checkbox node-key="menuKey" :props="{ label: 'name' }"
                        :filter-node-method="filterNode" @check-change="selectMenuEvents">
                    </el-tree>
                </div>
            </div>
            <div class="right">
                <div class="title">{{ $t('shortCutMenu.selectedFunctions') }}
                    <span class="tips">{{ $t('shortCutMenu.totalCount', { count: selectMenuList.length }) }}</span>
                </div>
                <div class="content">
                    <el-input :placeholder="$t('shortCutMenu.menuSearch')" size="mini" v-model="rightSearchValue"
                        @keyup.enter.native="rightSearchEvents">
                        <el-button slot="append" icon="el-icon-search" @click="rightSearchEvents"></el-button>
                    </el-input>
                    <div class="right_wrapper">
                        <draggable v-model="selectMenuList"
                            :disabled="selectMenuList.length != filterSelectMenuList.length">
                            <transition-group v-if="selectMenuList.length == filterSelectMenuList.length">
                                <div v-for="element in selectMenuList" class="sort-item" :key="element.key">
                                    <i class="iconfont icon-tuodong-line drag"></i>
                                    <div class="name">{{ element.name }}</div>
                                    <el-tooltip placement="top" effect="dark" :content="$t('common.delete')">
                                        <i class="iconfont icon-guanbi-line close" @click="deleteItem(element)"></i>
                                    </el-tooltip>

                                </div>
                            </transition-group>
                            <transition-group v-else>
                                <div v-for="element in filterSelectMenuList" class="sort-item" :key="element.key">
                                    <div class="name">{{ element.name }}</div>
                                    <i class="iconfont icon-guanbi-line close" @click="deleteItem(element)"></i>
                                </div>
                            </transition-group>
                        </draggable>
                    </div>
                </div>
            </div>
        </el-dialog>
        <div class="shortcut-menu-mask" v-if="showMask">
            <div class="view" ref="copy">
                <div class="copy">
                    <i class="iconfont icon-kuaijiecaidan-fill"></i>
                    <span>{{ $t('shortCutMenu.shortcutEntry') }}</span>
                </div>
            </div>
            <div class="wrapper" ref="wrapper">
                <div class="iconWrapper">
                    <i class="icon el-icon-close" @click="closeMask"></i>
                </div>
                <img :src="imgUrl" alt="" style="width: 336px; height: 120px;">
                <div class="title">{{ $t('shortCutMenu.addShortcutEntry') }}</div>
                <div class="description">{{ $t('shortCutMenu.addShortcutEntryDesc') }}</div>
                <el-button class="btn" size="mini" type='primary' @click="closeMask">{{ $t('common.iknow') }}</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
import _ from 'lodash'
import imgUrl from '@/assets/images/shotcutmenu.png'
import EmptyUrl from '@/assets/images/img_empty@2x.png'
import { mapState, mapActions } from 'vuex'
import { postShortcutMenuSave } from '@/api'
import { hmt_statistic } from "@/utils/index";

export default {
    name: 'shortCutMenu',
    components: {
        draggable
    },
    data() {
        return {
            loading: false,
            imgUrl,
            EmptyUrl,
            timer: null,
            resizeObserver: null, // 监听dom尺寸变化，因为左边的菜单栏时根据接口返回值刷新的，那么mask蒙层的位置会有改变
            showMask: !localStorage.getItem('shortCutMenu'), // 第一次进来显示蒙层引导箭头提示，以后就不会了
            showConfig: false, // 是否显示自定义配置弹窗
            leftSearchValue: '', // 配置弹窗的左边input框的值
            rightSearchValue: '', // 配置弹窗的右边input框的值
            selectMenuList: [], // 所有选中的菜单列表
            filterSelectMenuList: [], //自定义配置弹窗右边右input框筛选，所以这个是筛选过后的选中菜单列表
        }
    },
    computed: {
        //拿到 vuex中的用户信息 （userInfo） 和 菜单tree （menuList）
        ...mapState(["userInfo", 'menuList']),
        // 将菜单tree结构（menuList） 转换成一维数组，方便以后进行查找，还有一点是跳转url时需要携带的各种参数
        allMenu() {
            return this.expandArray(this.menuList);
        }
    },
    watch: {
        // 保存的快捷菜单数据史存放在用户信息里面的，所以要监听该值，从而获取（selectMenuList）
        'userInfo.ccShortcutMenu': {
            handler(val) {
                this.getCheckedArr(val, this.allMenu)
            },
            immediate: true
        },
        // 因为allMenu 也是根据 menuList转换而来，menuList也是焦勇接口获取，开始是没值的，所以也要watch。实时获取（selectMenuList）
        allMenu: {
            handler(val) {
                this.getCheckedArr(this.userInfo.ccShortcutMenu, val)
            },
            immediate: true
        },
        // 关闭蒙层后，监听dom变化的函数需要取消
        showMask(val) {
            if (!val) {
                this.resizeObserver.disconnect();
            }
        },
        // 打开自定义配置弹窗时，tree组件设置默认勾选项，为什么不在el-tree中设置属性？因为element-ui没有提供这个属性，只有default默认属性。默认属性不满足需求
        showConfig(val) {
            if (val) {
                setTimeout(() => {
                    this.$refs.tree.setCheckedKeys(this.selectMenuList.map(i => i.key))
                }, 100)
            }
            // 关闭或者打开自定义配置弹窗时，重新获取选中菜单
            this.getCheckedArr(this.userInfo.ccShortcutMenu, this.allMenu)
        },
        // 实时根据选中菜单设置tree组件的勾选项，如果不监听，删除选中项时，勾选项无法取消
        selectMenuList: {
            handler(val) {
                try {
                    this.$refs.tree.setCheckedKeys(val.map(i => i.key))
                } catch (error) { }
            },
            immediate: true
        }
    },
    mounted() {
        // 初始化时，第一次会有一个箭头指引的蒙层，有一个问题是，刚开始左边菜单栏没有数据，宽度为0，那么蒙层中的dom位置，无法确定，所以要监听菜单栏
        this.resizeObserver = new ResizeObserver(() => {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => this.handleResize(), 100);
        });
        // 监听菜单栏dom属性
        this.resizeObserver.observe(document.querySelector('.ekt-menu'));
        this.$once("hook:beforeDestroy", () => {
            this.resizeObserver.disconnect();
        });

    },
    methods: {
        // 获取url跳转方法
        ...mapActions(["addTab"]),
        findRepeatEle(arr, key) {
            let obj = {};
            let result = []
            arr.forEach(i => {
                let keys = i[key]
                if (obj[keys] == 1) {
                    obj[keys] += 1
                    result.push(arr.find(i => i[key] == keys))
                    result.push(i)
                } else if (obj[keys] > 1) {
                    result.push(i)
                } else {
                    obj[keys] = 1
                }
            })
            return result.length == 0 ? false : result
        },
        showPopoverEvents() {
            hmt_statistic(location.href, '快捷入口')
        },
        // 点击自定义时调用
        showConfigEvents() {
            this.showConfig = true
            hmt_statistic(location.href, '快捷入口-自定义')
        },
        // 关闭箭头指引蒙层
        closeMask() {
            this.showMask = false
            localStorage.setItem('shortCutMenu', 1)
        },
        // 监听函数
        handleResize() {
            try {
                var info = this.$refs.root.getBoundingClientRect()
                this.$refs.copy.style.left = (info.left - 10) + 'px';
                this.$refs.copy.style.top = (info.top - 4) + 'px';
                this.$refs.wrapper.style.left = (info.left - 10) + 'px';
            } catch (error) { }
        },
        // tree组件筛选时用到
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        // tree组件筛选时input框的搜索事件
        leftSearchEvents() {
            this.$refs.tree.filter(this.leftSearchValue)
        },
        // tree组件选中项变化时触发
        selectMenuEvents(item, checked, childrenChecked) {
            if (checked & !childrenChecked) {  // 如果是选中状态
                // 获取所有带url的菜单，一定要去重，因为有可能勾选父级
                let select = _.uniqBy(this.expandObject(item), 'menuKey')
                // 根据选中菜单获取包装后的带有所有属性的最终菜单，因为跳转时所需的属性 menuList中是没有的，所以一定包装一下
                let packageSelect = select.map(item => {
                    return this.allMenu.find(i => i.key == item.menuKey)
                }).filter(Boolean)
                this.selectMenuList = this.selectMenuList.concat(packageSelect)
                // 保险起见，再去重一下
                this.selectMenuList = _.uniqBy(this.selectMenuList, 'key')
            } else if (!checked & !childrenChecked) { // 如果是反选
                // 原因同上，拿到所有带url菜单，然后去重
                let select = _.uniqBy(this.expandObject(item), 'menuKey')
                this.selectMenuList = this.selectMenuList.filter(i => {
                    let arr = select.map(i => i.menuKey)
                    return !arr.includes(i.key)
                })
            }
            // 选中或者反选时，右边直接显示全部选中项
            this.filterSelectMenuList = this.selectMenuList
        },
        // 提交保存
        submit() {
            this.loading = true;
            const data = this.selectMenuList.map(i => ({ key: i.key, name: i.name }))
            postShortcutMenuSave(data).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: this.$t('common.saveSuccess'),
                        type: 'success'
                    })
                    this.showConfig = false
                    try {
                        if (Array.isArray(res.data.config)) {
                            // 更新vuex中的userInfo
                            this.$store.dispatch('changeUserInfo', { ...this.userInfo, ccShortcutMenu: res.data.config })
                        }
                    } catch (error) { }
                }
            }).finally(() => this.loading = false)
        },
        // 工具函数，见使用位置
        expandObject(obj) {
            let result = []
            if (!obj.children && obj.url) {
                result.push(obj)
            } else if (Array.isArray(obj.children)) {
                obj.children.forEach(i => {
                    result = result.concat(this.expandObject(i))
                })
            }
            return result
        },
        // 右边input框的查询事件
        rightSearchEvents() {
            this.filterSelectMenuList = this.selectMenuList.filter(i => i.name.includes(this.rightSearchValue))
        },
        // 删除选中菜单
        deleteItem(item) {
            this.selectMenuList = this.selectMenuList.filter(i => i.key != item.key)
            this.filterSelectMenuList = this.filterSelectMenuList.filter(i => i.key != item.key)
        },
        //将深层数组转换成一维数组：将menuList tree结构转换成一维数组,然后把url跳转时所需的属性（fullPath，fullName，subActive，thdActive）计算出来
        expandArray(array, parentMenuKey, parentMenuName) {
            if (!Array.isArray(array)) {
                return [];
            }
            parentMenuKey = parentMenuKey || [];
            parentMenuName = parentMenuName || [];
            let result = [];
            array.forEach(i => {
                if (Array.isArray(i.children)) {
                    result.push(
                        ...this.expandArray(
                            i.children,
                            [...parentMenuKey, i.menuKey],
                            [...parentMenuName, i.name]
                        )
                    );
                } else {
                    let fullPath = [...parentMenuKey, i.menuKey];
                    let fullName = [...parentMenuName, i.name];
                    let subPath = [];
                    let thdPath = [];
                    if (fullPath.length >= 5) {
                        subPath = fullPath.slice(1, 3);
                        thdPath = fullPath.slice(3);
                    } else {
                        subPath = fullPath.slice(1);
                    }
                    let item = {
                        fullPath,
                        fullName,
                        icon: i.icon,
                        key: i.menuKey,
                        mainMenuKey: fullPath[0],
                        subActive: {
                            path: subPath,
                            key: subPath[subPath.length - 1]
                        },
                        thdActive: {
                            path: thdPath,
                            key: thdPath[thdPath.length - 1]
                        },
                        name: i.name,
                        refresh: true,
                        url: i.url,
                        type: i.type
                    };
                    result.push(item);
                }
            });
            // 将重名菜单的name转换成带有上级目录
            let repeatEle = this.findRepeatEle(result, 'name')
            if (repeatEle) {
                repeatEle.forEach(i => {
                    if (Array.isArray(i.fullName) && i.fullName[i.fullName.length - 2]) {
                        i.name = `${i.name} (${i.fullName[i.fullName.length - 2]})`
                    }
                })
            }
            return result;
        },
        getCheckedArr(config, allMenu) {
            if (!Array.isArray(config) || !Array.isArray(allMenu)) {
                this.selectMenuList = []
                return
            }
            if (config.length == 0 || allMenu.length == 0) {
                this.selectMenuList = []
                return
            }
            let result = []
            config.forEach(i => {
                let key = i.key
                let item = allMenu.find(i => i.key == key)
                result.push(item)
            })
            this.selectMenuList = result.filter(Boolean)
        },
        jumpUrl(item) {
            this.addTab(item)
            this.$nextTick(_ => {
                this._Bus.$emit("clickTab", item);
            })
        }
    }

}
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>
<style lang="less">
.shortcut-menu-prpover {
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/view/Home/shortCutMenu/index.vue